import { PlusIcon } from 'lucide-react';
import * as React from 'react';
import { Button } from '../../../components/ui/button.tsx';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { DropdownMenuItemCreateEvent } from '../../events/components/dropdown-menu-item-create-event.tsx';
import { DropdownMenuItemCreateNote } from '../../notes/components/dropdown-menu-item-create-note.tsx';
import { DropdownMenuItemCreateDraft } from '../../sales-draft/components/dropdown-menu-item-create-draft.tsx';
import { DropdownMenuItemCreateTask } from '../../tasks/components/dropdown-menu-item-create-task.tsx';

export type CreateNewOrderMenuProps = {
    showFullInput?: boolean;
    className?: string;
    onClose?: () => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const CreateNewMenu = React.forwardRef<HTMLInputElement, CreateNewOrderMenuProps>(
    ({ showFullInput = true, onClose = () => {} }, ref) => {
        const { t } = useLocale();
        const [open, setOpen] = React.useState(false);

        const closeMenu = () => {
            setOpen(false);
            onClose();
        };

        return (
            <DropdownMenu open={open} onOpenChange={setOpen}>
                <DropdownMenuTrigger asChild>
                    {showFullInput ? (
                        <Button
                            className="w-full justify-start"
                            variant="ghost"
                            selected={open}
                            onClick={() => {
                                setOpen(true);
                            }}
                            leftIcon={PlusIcon}
                        >
                            <span>{t('top_navbar__new_actvity')}</span>
                        </Button>
                    ) : (
                        <Button
                            size="icon-s"
                            variant="outline"
                            selected={open}
                            onClick={() => {
                                setOpen(true);
                            }}
                        >
                            <PlusIcon className="flex h-4 w-4 shrink-0 " />
                        </Button>
                    )}
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" side="right" className="z-9999">
                    <DropdownMenuItemCreateTask links={[]} />
                    <DropdownMenuItemCreateDraft />
                    <DropdownMenuItemCreateEvent analyticsSource="menu" />
                    <DropdownMenuItemCreateNote analyticsSource="side_menu" />
                </DropdownMenuContent>
            </DropdownMenu>
        );
    },
);

CreateNewMenu.displayName = 'CreateNewMenu';

export { CreateNewMenu };
